import { apiFetch, withToken } from "./http";

// Tanıtım e-postası ölçümü. Mailleri excopan.com gönderir; burada kimin
// açtığı, kimin siteye geldiği ve hangi sayfaları gezdiği tutulur.

export type MailTrackingRow = {
  id: number;
  campaign: string;
  send_id: number;
  subject?: string;
  email: string;
  name?: string;
  sent_at?: string | null;

  opened_at?: string | null;
  last_open_at?: string | null;
  open_count: number;
  open_ip?: string;
  open_agent?: string;

  click_count: number;
  last_click_at?: string | null;

  // Sitede gezilen sayfa sayısı (girişten sonraki gezinti).
  pageview_count: number;
};

export type MailClick = {
  id: number;
  url: string;
  clicked_at: string;
  ip?: string;
  user_agent?: string;
};

// MailPageview — ziyaretçinin siteye geldikten sonra açtığı sayfa.
export type MailPageview = {
  id: number;
  path: string;
  viewed_at: string;
  ip?: string;
  user_agent?: string;
  referer?: string;
  lang?: string;
};

// MailSend — bir gönderim = bir rapor. Aynı gün aynı konuyla parça parça
// gönderim tek rapordur; ertesi gün veya farklı konu yeni rapor açar.
export type MailSend = {
  id: number;
  campaign: string;
  subject: string;
  send_day: string;
  recipients: number;
  opened: number;
  clicked: number;
  visited: number;
};

// SiteVisitor — canlı ziyaretçi. Mailden gelmişse email/name dolu, anonim
// ziyaretçide boştur.
export type SiteVisitor = {
  visitor_key: string;
  email?: string;
  name?: string;
  campaign?: string;
  first_seen: string;
  last_seen: string;
  page_count: number;
  last_path: string;
  ip?: string;
  user_agent?: string;
  referer?: string;
  lang?: string;
};

export type MailCampaign = {
  campaign: string;
  recipients: number;
  opened: number;  // açan tekil kişi
  clicked: number; // tıklayan tekil kişi
};

export type MailTrackingDetail = {
  row: MailTrackingRow;
  clicks: MailClick[] | null;
  pageviews: MailPageview[] | null;
};

export type MailListResult = {
  items: MailTrackingRow[];
  total: number;
  page: number;
  per_page: number;
  campaigns: MailCampaign[];
  sends: MailSend[];
};

// Arama, sıralama ve sayfalama SUNUCU tarafındadır: 1500+ alıcılık bir
// kampanyada tüm listeyi indirip istemcide süzmek hem yavaş hem gereksiz.
export type MailListQuery = {
  campaign?: string;
  sendID?: number;
  q?: string;
  sort?: string;
  order?: "asc" | "desc";
  page?: number;
  perPage?: number;
};

async function jsonOrThrow<T>(res: Response, fallback: string): Promise<T> {
  if (!res.ok) {
    let msg = `${fallback} (HTTP ${res.status})`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

export async function listMailTracking(q: MailListQuery = {}): Promise<MailListResult> {
  const p = new URLSearchParams();
  if (q.campaign) p.set("campaign", q.campaign);
  if (q.sendID) p.set("send_id", String(q.sendID));
  if (q.q) p.set("q", q.q);
  if (q.sort) p.set("sort", q.sort);
  if (q.order) p.set("order", q.order);
  if (q.page) p.set("page", String(q.page));
  if (q.perPage) p.set("per_page", String(q.perPage));

  const res = await apiFetch(`/api/v1/admin/mail/tracking?${p.toString()}`);
  const d = await jsonOrThrow<MailListResult>(res, "Mail takip listesi alınamadı");
  return {
    items: d.items ?? [],
    total: d.total ?? 0,
    page: d.page ?? 1,
    per_page: d.per_page ?? 50,
    campaigns: d.campaigns ?? [],
    sends: d.sends ?? [],
  };
}

// Canlı ziyaretçiler — mailden gelmeyenler dahil.
export async function listVisitors(dakika = 30): Promise<SiteVisitor[]> {
  const res = await apiFetch(`/api/v1/admin/mail/tracking/visitors?dakika=${dakika}`);
  const d = await jsonOrThrow<{ items: SiteVisitor[] | null }>(res, "Ziyaretçiler alınamadı");
  return d.items ?? [];
}

// getVisitor — tek ziyaretçinin özeti + gezdiği sayfalar (detay sayfası).
export async function getVisitor(
  key: string,
): Promise<{ visitor: SiteVisitor | null; items: MailPageview[] }> {
  const res = await apiFetch(`/api/v1/admin/mail/tracking/visitors/${encodeURIComponent(key)}/pages`);
  const d = await jsonOrThrow<{ items: MailPageview[] | null; visitor: SiteVisitor | null }>(
    res, "Ziyaretçi bilgisi alınamadı");
  return { visitor: d.visitor ?? null, items: d.items ?? [] };
}

export async function getMailTrackingDetail(id: number): Promise<MailTrackingDetail> {
  const res = await apiFetch(`/api/v1/admin/mail/tracking/${id}`);
  return jsonOrThrow<MailTrackingDetail>(res, "Ziyaret detayı alınamadı");
}

// MailPurgeResult — ölçüm sıfırlandığında hangi tablodan kaç satır silindi.
// Listeden çıkanlar (unsubscribe) bu kapsamda DEĞİLDİR: ölçüm sıfırlanır,
// rıza sıfırlanmaz.
export type MailPurgeResult = {
  recipients: number;
  opens: number;
  clicks: number;
  pageviews: number;
  sends: number;
};

// purgeMailTracking — ölçümün tamamını siler. GERİ ALINAMAZ.
//
// Onay sözcüğü gövdede gider: uç, kimlik doğrulamasının yanında KASIT da
// arar. Elle atılan ya da kopyala-yapıştır bir DELETE isteği bu alan olmadan
// ölçümü silemez.
export async function purgeMailTracking(): Promise<{ deleted: MailPurgeResult; total: number }> {
  const res = await apiFetch("/api/v1/admin/mail/tracking", {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ onay: "SIL" }),
  });
  return jsonOrThrow<{ deleted: MailPurgeResult; total: number }>(res, "Kayıtlar silinemedi");
}

// mailEventsURL — SSE akışı. EventSource header gönderemediği için jeton
// sorgu dizesinde taşınır (destek akışıyla aynı yöntem).
export function mailEventsURL(): string {
  return withToken("/api/v1/admin/mail/tracking/events");
}
